import script from "./new_faq.vue?vue&type=script&setup=true&lang=js"
export * from "./new_faq.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__